export default __webpack_public_path__ + "SAs_headersGAP.html";